// extracted by mini-css-extract-plugin
export var form = "Form-module--form--9be92";
export var success = "Form-module--success--62719";
export var textarea = "Form-module--textarea--4b478";